<template>
  <!-- 付款计划新建修改 -->
  <a-modal
    :dialog-style="{ top: '20px' }"
    :title="title"
    :visible="isVisible"
    :destroyOnClose="true"
    :maskClosable="false"
    width="54%"
    @ok="handleOk"
    @cancel="close"
  >
    <div v-if="maskDiv" class="maskDiv" @click="maskClick">123</div>
    <div>
      <a-form-model
        ref="formRef"
        :model="form"
        labelAlign="right"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        :rules="rules"
      >
        <a-form-model-item
          label="对应项目"
          :labelCol="rowLabel"
          :wrapperCol="rowWrapper"
          prop="projectName"
        >
          <a-input
            style="cursor: pointer;"
            :disabled="(title === `[修改]-${this.$tree([], 'purchase/paymentSchedule/index')}` || title === `[编辑]-${this.$tree([], 'purchase/paymentSchedule/index')}`) && form.payStatus === 1"
            read-only
            v-model="form.projectName"
            class="choosePerson"
            placeholder="点击选择对应的项目"
            @click="openModal('project')"
          />
        </a-form-model-item>
        <a-form-model-item
          label="采购单"
          prop="purchaseName"
          :labelCol="rowLabel"
          :wrapperCol="rowWrapper"
        >
          <p
            class="choosePerson"
            @click="openModal('purchaseName')"
            :style="{
              color: form.purchaseName ? '#333' : '#ccc'
            }"
          >{{ form.purchaseName || '选择采购单' }}</p>
        </a-form-model-item>
        <a-form-model-item
          label="供应商"
          :labelCol="rowLabel"
          :wrapperCol="rowWrapper"
          prop="customerName"
        >
          <!-- <p class="choosePerson" @click="openModal('supplier')">{{ form.customerName || '选择供应商' }}</p> -->
          <a-input
            :disabled="isDisabled"
            read-only
            :class="disselectSupplier ? 'readOnly' : ''"
            @click="openModal('supplier')"
            v-model="form.customerName"
            class="choosePerson"
            placeholder="点击选择对应的供应商"
            style="cursor: pointer;"
          />
        </a-form-model-item>
        <!-- <div style="text-align: center; color: #1890ff; font-weight: 500;" v-if="payments">
        <span style="margin-right: 15px;">∑采购-付款：￥{{'0.00'}}</span>
        <span>∑收票-付款：￥{{'0.00'}}</span>
        </div>-->
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="款项日期" prop="payDate">
              <a-date-picker
                :disabled="isDisabled"
                @change="onChange"
                :default-value="moment().format('YYYY-MM-DD')"
                style="width: 100%;"
                valueFormat="YYYY-MM-DD"
                v-model="form.payDate"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="期次">
              <a-select
                show-search
                v-model="form.period"
                placeholder="选择期次"
                style="width: 100%"
                :disabled="isDisabled"
              >
                <a-select-option v-for="item in periods" :key="item">{{ item }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="付款金额" :labelCol="rowLabel" prop="payMoney">
              <a-input-number
                :disabled="isDisabled"
                :placeholder="placeholder"
                v-model="form.payMoney"
                :step="0.01"
                :precision="2"
                style="width: 60%;"
                @change="payMoneyBlur"
              />
              <!-- <a-input-number
              placeholder="输入付款金额"
              style="width: 20em;"
              v-model="form.payMoney"
              :step="0.01"
              :parser="value =>value.match(/^[0-9]*\.([0-9]{0,2})|^[0-9]*/)[0]"
              @change="payMoneyBlur" />-->
              <span style="position: relative; left: 9px;">{{ dealBigMoneyss || '零元' }}</span>
              <!-- <br><a-icon type="info-circle" theme="filled" style="margin-right: 6px;"/><b>提示: 预付金额（项目预付）+付款金额（付款记录）≤采购金额（采购单）时，才允许进行新增</b> -->
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="margin-left: 70px;margin-bottom: 20px;">
          <a-icon type="info-circle" theme="filled" style="margin-right: 6px;" />
          <!-- eslint-disable-next-line vue/no-parsing-error -->
          <b>提示: 项目付款计划/记录金额+预付已支取金额 <= 采购单总金额</b>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="冲销金额" prop="payCxMoney">
              <a-input-number
                :disabled="isDisabled"
                placeholder="输入冲销金额"
                v-model="form.payCxMoney"
                :step="0.01"
                :precision="2"
                style="width: 100%;"
              />
              <!-- <a-input-number
              placeholder="输入冲销金额"
              style="width: 20em;"
              v-model="form.payCxMoney"
              :step="0.01"
              :parser="value =>value.match(/^[0-9]*\.([0-9]{0,2})|^[0-9]*/)[0]" />-->
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="付款外币备注">
              <a-input
                :disabled="isDisabled"
                placeholder="输入付款外币备注"
                v-model="form.payForeignRemark"
                style="width: 100%;"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="负责人">
              <p
                class="choosePerson"
                @click="openPerson('charge')"
              >{{ form.dutyPerson || this.getLocal() }}</p>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="所有者" prop="payOwner">
              <p
                class="choosePerson"
                style="width: 100%;"
                @click="openPerson('owner')"
              >{{ form.payOwner || this.getLocal() }}</p>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-form-model-item label="备注" :labelCol="rowLabel" :wrapperCol="rowWrapper">
          <a-textarea
            :disabled="isDisabled"
            :auto-size="{ minRows: 3, maxRows: 10 }"
            style="width: 100%;"
            v-model="form.payRemark"
          />
        </a-form-model-item>
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="是否付款" :labelCol="rowLabel" :wrapperCol="rowWrapper">
              <a-radio-group
                name="radioGroup"
                :disabled="disabled"
                @change="radioChange"
                v-model="form.payStatus"
              >
                <a-radio :value="0">未付</a-radio>
                <a-radio :value="1">已付</a-radio>
              </a-radio-group>
              <!-- <span>
                <a-checkbox @change="onisChange" :checked="ischecked" v-if="isRecords">生成付款记录</a-checkbox>
              </span>-->
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row v-if="generated">
          <a-col :span="12">
            <a-form-model-item label="实际付款日期">
              <a-date-picker
                :disabled="isDisabled"
                @change="onChangePractical"
                style="width: 100%;"
                :default-value="moment().format('YYYY-MM-DD')"
                valueFormat="YYYY-MM-DD"
                v-model="form.payDateActual"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="实际付款金额" prop="payMoneyActual">
              <a-input-number
                :disabled="isDisabled"
                placeholder="输入付款实际付款金额"
                v-model="form.payMoneyActual"
                :step="0.01"
                :min="0"
                :precision="2"
                style="width: 100%"
              />
              <!-- <a-input-number
              placeholder="输入付款实际付款金额"
              style="width: 23em;"
              v-model="form.payMoneyActual"
              :step="0.01"
              :parser="value =>value.match(/^[0-9]*\.([0-9]{0,2})|^[0-9]*/)[0]" />-->
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row v-if="generated">
          <a-col :span="12">
            <a-form-model-item label="付款方式" prop="payMode">
              <a-select v-model="form.payMode" show-search placeholder="请选择" style="width: 100%">
                <a-select-option
                  v-for="(item, index) in paymentMethodList"
                  :key="index"
                  :value="item.label"
                >{{item.value}}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="金额大写">
              <span>{{ dealBigMoneys(form.payMoneyActual) || '零元' }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item
              label="收到发票"
              prop="payInvoice"
              :labelCol="rowLabel"
              :wrapperCol="rowWrapper"
            >
              <a-radio-group
                name="radioGroup"
                :disabled="disabled"
                v-model="form.payInvoice"
                @change="isInvoice"
              >
                <a-radio :value="0">未收发票</a-radio>
                <a-radio :value="1">已收发票</a-radio>
                <a-radio :value="2">无需收票</a-radio>
              </a-radio-group>
              <span>
                <a-checkbox @change="onisChanges" :checked="ischeckeds" v-if="isTicket">生成收票记录</a-checkbox>
              </span>
            </a-form-model-item>
          </a-col>
        </a-row>
        <div v-if="iscollection">
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                label="发票内容"
                prop="invoiceBo.invoiceContent"
                :labelCol="rowLabel"
                :wrapperCol="rowWrapper"
              >
                <a-input
                  :disabled="isDisabled"
                  v-model="form.invoiceBo.invoiceContent"
                  style="width: 100%;"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="票据类型" prop="invoiceBo.invoiceType">
                <a-select
                  style="width: 100%"
                  v-model="form.invoiceBo.invoiceType"
                  :disabled="isDisabled"
                  @change="ticketReceiptClick"
                >
                  <a-select-option
                    v-for="(item, index) in billTypeList"
                    :key="index"
                    :value="item.label"
                  >{{ item.value }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="计算进顶税">
                <a-tooltip placement="topLeft" title="进顶税金计算说明：计算进项税时，进项税金=开票金额*税率/(1+税率)">
                  <a-icon type="warning" theme="filled" style="color: #ECD5A2; padding: 0px 6px;" />
                </a-tooltip>
                <a-radio-group
                  name="radioGroup"
                  :default-value="1"
                  v-model="form.invoiceBo.includingTax"
                  @change="isRadioGroups"
                  :disabled="isDisabled || isincludingTax"
                >
                  <a-radio :value="0">计算</a-radio>
                  <a-radio :value="1">不计算</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="发票号码" prop="invoiceNum">
                <a-input
                  :disabled="isDisabled"
                  v-model="form.invoiceBo.invoiceNum"
                  style="width: 100%;"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="发票金额" prop="invoiceBo.invoiceMoney">
                <a-input-number
                  :disabled="isDisabled"
                  placeholder="输入发票金额"
                  style="width: 100%;"
                  v-model="form.invoiceBo.invoiceMoney"
                  :step="0.01"
                  :min="0"
                  :precision="2"
                  @blur="isTaxes"
                />
                <!-- <a-input-number
                placeholder="输入发票金额"
                style="width: 23em;"
                v-model="invoiceBo.invoiceMoney"
                :step="0.01"
                :parser="value =>value.match(/^[0-9]*\.([0-9]{0,2})|^[0-9]*/)[0]"
                @blur="isTaxes" />-->
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="税率" prop="invoiceBo.taxRate">
                <a-input
                  :disabled="isDisabled"
                  style="width: 95%;"
                  @blur="isTaxs"
                  v-model="form.invoiceBo.taxRate"
                />
                <span>%</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="税金">
                <span>{{form.invoiceBo.taxes}}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="抄送人" :labelCol="rowLabel" :wrapperCol="rowWrapper">
              <!-- <p class="choosePerson" @click="openPerson('user')">{{ form.userName || '点击选择抄送人' }}</p> -->
              <a-input
                :disabled="isDisabled"
                style="cursor: pointer; width: 100%;"
                read-only
                v-model="form.userName"
                class="choosePerson"
                placeholder="点击选择抄送人"
                @click="openPerson('user')"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="上传附件" :labelCol="rowLabel" :wrapperCol="rowWrapper">
              <upload-attachment
                ref="uploadRef"
                :val-name="valName"
                :class="isDisabled ? 'isDisabled' : ''"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <template #footer>
      <a-button @click="close" style="background-color:#F2F2F2">取消</a-button>
      <a-button type="primary" :loading="loading" @click="handleOk(0)">保存</a-button>
      <a-button
        @click="handleOk(1)"
        :loading="loading"
        style="background-color:#52c41a;color:#fff;"
      >保存并提交审核</a-button>
    </template>
    <personnel
      :visible="personVisible"
      :chooseData="chooseData"
      :isOnce="isOnce"
      @close="personClose"
      @success="personSuccess"
    />
    <publicDialog
      :title="publicDia.title"
      :projectId="publicDia.projectId"
      :dialog-visible="publicDia.visible"
      :component-name="publicDia.comName"
      @logSuccess="publicDialogSucc"
      @cancel="handleClose"
    />
  </a-modal>
</template>

<script>
import moment from 'moment'
import publicDialog from '../../../components/modelDialog/publicDialog.vue'
import personnel from '../../../components/personnel'
import { dealBigMoneys, taxComputation } from '../../../utils/common'
import uploadAttachment from '../../common/Upload.vue'
import { getDefaultCarbonPerson } from '@/utils/index.js'
// import {getProjectNameById} from '../../../utils/index'

export default {
  name: 'addEditSch',
  components: { publicDialog, personnel, uploadAttachment },
  props: {
    title: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  provide () {
    return {
      formData: this
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.dialogVisible
      },
      set () {
        this.close()
      }
    }
  },
  data () {
    let checkMoney = (rule, value, callback) => {
      const reg = /^-?(0|[1-9]\d*)(\.\d{1,2})?$/
      if (!reg.test(value)) {
        // eslint-disable-next-line standard/no-callback-literal
        return callback('请输入付款金额，最多可保留两位小数！')
      }
      callback()
    }
    return {
      disselectSupplier: false, // 采购单新建时供应商不允许选择
      paymentMethodList: [],
      paymentMethodObj: {},
      disabled: false,
      payments: false,
      maskDiv: false,
      ischecked: false,
      ischeckeds: false,
      userDisabled: false,
      loading: false,
      dealBigMoneyss: '',
      disbledClick: false,
      isOnce: false,
      personVisible: false,
      personData: {}, // 选择人员数据
      // nameObj: {},
      dataValue: {},
      billTypeList: [],
      rules: {
        projectName: [{ required: true, message: '请选择对应项目', trigger: 'change' }],
        customerName: [{ required: true, message: '请选择对应供应商', trigger: 'change' }],
        payDate: [{ required: true, message: '请选择时间', trigger: 'change' }],
        payMoney: [{ required: true, validator: checkMoney, trigger: 'blur' }],
        payCxMoney: [{ required: true, message: '请输入冲销金额，最多可保留两位小数！', trigger: 'blur' }],
        payOwner: [{ required: true, message: '请选择所有者', trigger: 'blur' }],
        payInvoice: [{ required: true, message: '请选择是否收到发票', trigger: 'change' }],
        purchaseName: [{ required: true, message: '请选择采购单', trigger: 'change' }],
        period: [{ required: true, message: '请选择期次', trigger: 'change' }],
        payMoneyActual: [{ required: true, message: '请输入实际付款金额，最多可保留两位小数！', trigger: 'blur' }],
        payMode: [{ required: true, message: '请选择付款方式', trigger: 'blur' }],
        invoiceBo: {
          invoiceContent: [{ required: true, message: '请输入内容摘要', trigger: 'blur' }],
          invoiceType: [{ required: true, message: '请选择票据类型', trigger: 'change' }],
          invoiceMoney: [{ required: true, message: '请输入发票金额', trigger: 'blur' }],
          taxRate: [{ required: true, message: '请输入税率', trigger: 'blur' }]
        }
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      rowLabel: { span: 3 },
      rowWrapper: { span: 19 },
      isProjectType: true,
      isRecords: false,
      generated: false,
      isTicket: false,
      provinceData: ['Zhejiang', 'Jiangsu'],
      iscollection: false,
      dialogVisibles: false,
      componentName: '',
      uploadFileList: [],
      customerId: '',
      purchaseId: '',
      valName: 'uploadFileList',
      openPersonType: '',
      publicDia: {
        title: '',
        visible: false,
        comName: '',
        projectId: ''
      },
      periods: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      form: {
        projectName: '', // 对应项目
        purchaseName: '', // 对应采购单
        companyName: '', // 供应商(客户)
        payDate: moment().format('YYYY-MM-DD'), // 款项日期
        // period: '', // 期次
        // payMoney: '', // 付款金额
        // payRemark: '', // 备注
        // payCxMoney: '', // 冲销金额
        // dutyPerson: '', // 负责人
        // payOwner: '', // 所有者
        // notes: '', // 付款外币备注
        payInvoice: 0, // 收到发票
        payStatus: 0, // 是否付款
        payType: 0,
        payDateActual: null, // 实际付款日
        customerId: '',
        purchaseId: '',
        invoiceBo: {
          taxRate: '', // 税率
          taxes: '', // 税金
          // invoiceContent: '', // 票据内容
          invoiceMoney: '', // 票据金额
          // invoiceNum: '', // 发票号码
          includingTax: 1 // 是否含税(0 含 1 不含)
          // invoiceType: '' // 票据类型(字典)
        }
      },
      procurement: [], // 采购单选择
      chooseData: {}, // 选择的人员数据
      isDisabled: false, // 审核通过允许修改对应项目
      maxPlanMoney: 0, // 付款金额限制
      editMaxPlanMoney: 0, // 修改时付款金额限制
      editPlanMoneyId: null, // 修改时采购单id
      placeholder: '输入付款金额', // 付款金额提示
      isincludingTax: false
    }
  },
  watch: {
    isRecords: {
      handler (newVal, oldVal) {
        if (newVal) {
          this.form.payDateActual = moment().format('YYYY-MM-DD')
        } else {
          this.form.payDateActual = null
        }
      },
      immediate: true
    },
    maxPlanMoney: {
      handler (newVal, oldVal) {
        if (newVal === Infinity) {
          this.placeholder = '输入付款金额'
        }
      },
      immediate: true
    },
    isVisible (newVal, oldVal) {
      if (newVal) {
        this.form.payDate = moment().format('YYYY-MM-DD')
      }
    }
  },
  mounted () {
    this.billTypeList = this.$store.state.account.dictData.billTypeList
    this.paymentMethodList = this.$store.state.account.dictData.paymentMethodList
    this.paymentMethodObj = this.$store.state.account.dictData.paymentMethodObj
    this.form.payOwner = this.getLocal()
    this.form.dutyPerson = this.getLocal()
  },
  methods: {
    moment,
    dealBigMoneys,
    ticketReceiptClick (e) {
      // console.log(e, '========')
      if (e === '406') {
        this.$set(this.form.invoiceBo, 'includingTax', 1)
        this.$set(this.form.invoiceBo, 'taxRate', 0)
        this.$set(this.form.invoiceBo, 'taxes', '')
        this.isincludingTax = false
      } else if (e === '175') {
        this.$set(this.form.invoiceBo, 'includingTax', 0)
        this.$set(this.form.invoiceBo, 'taxRate', '')
        this.$set(this.form.invoiceBo, 'taxes', '')
        this.isincludingTax = true
      } else {
        this.isincludingTax = false
        this.$set(this.form.invoiceBo, 'taxRate', '')
        this.$set(this.form.invoiceBo, 'taxes', '')
      }
    },
    getDefaultPerson () {
      getDefaultCarbonPerson(3).then((res) => {
        if (res) {
          this.$set(this.form, 'userId', res.userIdList)
          this.$set(this.form, 'userName', res.userNameList)
        }
      })
    },
    isTaxs (val) {
      if (this.form.invoiceBo.invoiceMoney !== '' && this.form.invoiceBo.includingTax === 0) {
        this.form.invoiceBo.taxes = taxComputation(this.form.invoiceBo.invoiceMoney, val.target.value)
      }
    },
    isTaxes (e) {
      if (this.form.invoiceBo.taxRate !== '' && this.form.invoiceBo.includingTax === 0) {
        this.form.invoiceBo.taxes = taxComputation(e.target.value, this.form.invoiceBo.taxRate)
      }
    },
    isRadioGroups (val) {
      if (val.target.value === 0 && this.form.invoiceBo.taxRate !== '' && this.form.invoiceBo.invoiceMoney !== '') {
        this.form.invoiceBo.taxes = taxComputation(this.form.invoiceBo.invoiceMoney, this.form.invoiceBo.taxRate)
      } else if (val.target.value === 1) {
        this.form.invoiceBo.taxes = ''
      }
    },
    payMoneyBlur (val) {
      this.form.payCxMoney = val
      this.dealBigMoneyss = dealBigMoneys(val)
    },
    personClose () {
      this.personVisible = false
    },
    publicDialogSucc (data, typeVal) {
      if (typeVal === 'projectManage') {
        this.$set(this.form, 'projectName', data.subject)
        this.$set(this.form, 'projectId', data.id)
        if (data.customerType === 2) {
          this.$set(this.form, 'customerName', data.mainCustomer)
          this.$set(this.form, 'customerId', data.mainCustomerId)
        } else {
          this.$set(this.form, 'customerName', '')
          this.$set(this.form, 'customerId', '')
        }
        // this.procurementSelect()
        this.restProject()
        this.$refs.formRef && this.$refs.formRef.clearValidate('projectName')
      } else if (typeVal === 'purchase/supplier') {
        this.$set(this.form, 'customerName', data.companyName)
        this.$set(this.form, 'customerId', data.id)
        this.$refs.formRef && this.$refs.formRef.clearValidate('customerName')
        this.payments = true
      } else if (typeVal === 'purchase/purchaseNote') {
        this.$set(this.form, 'purchaseName', data.subject)
        this.$set(this.form, 'purchaseId', data.id)
        if (this.form.purchaseId === this.editPlanMoneyId) {
          this.checkAmountLimit(this.form.purchaseId, 0)
        } else {
          if (this.title === `[新建]-${this.$tree([], 'purchase/paymentSchedule/index')}`) {
            this.checkAmountLimit(this.form.purchaseId, 0)
          } else {
            this.checkAmountLimit(this.form.purchaseId, 1)
          }
        }
        this.$refs.formRef && this.$refs.formRef.clearValidate('purchaseName')
      } else if (typeVal === 'purchaseNote') {
        this.$set(this.form, 'purchaseName', data.subject)
        this.$set(this.form, 'purchaseId', data.id)
        this.$refs.formRef && this.$refs.formRef.clearValidate('purchaseName')
        this.payments = true
        this.$nextTick(() => {
          if (this.form.purchaseId === this.editPlanMoneyId) {
            this.checkAmountLimit(this.form.purchaseId, 0)
          } else {
            if (this.title === `[新建]-${this.$tree([], 'purchase/paymentSchedule/index')}`) {
              this.checkAmountLimit(this.form.purchaseId, 0)
            } else {
              this.checkAmountLimit(this.form.purchaseId, 1)
            }
          }
        })
      } else if (typeVal === 'disselect') {
        this.disselectSupplier = true
      }
      this.resetDialogData()
    },
    restProject () {
      // this.$set(this.form, 'customerName', null)
      // this.$set(this.form, 'customerId', null)
      this.$set(this.form, 'purchaseName', null)
      this.$set(this.form, 'purchaseId', null)
      this.$set(this.form, 'planRecordId', null)
      this.$set(this.form, 'payMoney', 0)
      this.$set(this.form, 'payCxMoney', 0)
    },
    personSuccess (data, type) {
      var username, userId
      // 单选 和 多选 人员数据
      if (type === 'checkType') {
        data.forEach(item => {
          if (!username) {
            username = item.username
            userId = item.userId
          } else {
            username += ',' + item.username
            userId += ',' + item.userId
          }
        })
      } else if (type === 'radioType') {
        username = data.username
        userId = data.userId
      }
      // 判断数据赋值
      if (this.openPersonType === 'user') {
        this.form.userId = userId
        this.form.userName = username
      } else if (this.openPersonType === 'charge') {
        // this.form.charge = userId
        this.form.dutyPerson = username
      } else if (this.openPersonType === 'owner') {
        // this.form.owner = userId
        // this.form.payOwner = username
        this.$set(this.form, 'payOwner', username)
      }
      this.personVisible = false
    },
    openPerson (type) {
      if (this.isDisabled) return
      this.openPersonType = type
      // 抄送人为多选  负责人和所有者单选
      if (type === 'user') {
        this.isOnce = false
      } else {
        this.isOnce = true
      }
      this.personVisible = true
      this.chooseData = { userId: this.dataValue[type + 'Id'], userName: this.dataValue[type + 'Name'], roleId: this.dataValue.checkRoleId, roleName: this.dataValue.checkRoleName }
    },
    dropdownVisibleChanged () {
      if (!this.form.projectId || this.form.projectId === '') {
        this.$message.warning('请先选择项目')
      }
    },
    openModal (type) {
      if (type === 'supplier') {
        if (this.disselectSupplier) return
        this.publicDia.visible = true
        this.publicDia.title = '选择对应供应商'
        this.publicDia.comName = 'purchase/supplier'
        // this.$get('/purchase/list', {supplier_id: this.customerId}).then(res => {
        //   this.procurement = res.data.data.rows
        // })
      } else if (type === 'purchaseName') {
        if (!this.form.projectId || this.form.projectId === '') {
          this.$message.warning('请先选择项目')
          return
        }
        this.publicDia.projectId = this.form.projectId
        this.publicDia.visible = true
        this.publicDia.title = '选择对应采购单'
        this.publicDia.comName = 'purchase/purchaseNote'
      } else if (type === 'project') {
        this.publicDia.visible = true
        this.publicDia.title = '选择对应项目'
        this.publicDia.comName = 'projectManage'
      }
    },
    subjectCahnge (val, option) {
      this.$set(this.form, 'purchaseName', this.procurement[val].subject)
      this.$set(this.form, 'purchaseId', this.procurement[val].id)
      // this.$set(this.form, 'customerName', option.data.attrs.customerName)
      // this.$set(this.form, 'customerId', option.data.attrs.customerId)
      // this.form.purchaseName = this.procurement[val].subject
      // this.form.purchaseId = this.procurement[val].id
      if (this.form.purchaseId === this.editPlanMoneyId) {
        this.checkAmountLimit(this.form.purchaseId, 0)
      } else {
        if (this.title === `[新建]-${this.$tree([], 'purchase/paymentSchedule/index')}`) {
          this.checkAmountLimit(this.form.purchaseId, 0)
        } else {
          this.checkAmountLimit(this.form.purchaseId, 1)
        }
      }
    },
    // 查采购单
    procurementSelect (val) {
      this.$get('/purchase/getByProjectId', { projectId: this.form.projectId, purchaseSource: 0 }).then(res => {
        res.data.data.rows.forEach(item => {
          this.$set(item, 'subject', `${item.subject}(采购单号：${item.code}， 创建人：${item.creator}，状态：${item.status === 0 ? '执行中' : item.status === 1 ? '结束' : '意外中止'})`)
        })
        this.procurement = res.data.data.rows
      })
    },
    // 查看金额限制
    checkAmountLimit (id, isChange) {
      this.$get('/payPlan/getMaxPlanMoney', { purchaseId: id, money: this.editMaxPlanMoney, isChange }).then(res => {
        if (res.data.status === 1) {
          // console.log(this.maxPlanMoney, res.data.data.maxPlanMoney)
          this.maxPlanMoney = res.data.data.maxPlanMoney
          // if (this.maxPlanMoney && this.maxPlanMoney !== '' && this.maxPlanMoney !== null) {
          //   this.$set(this.form, 'payMoney', this.maxPlanMoney)
          //   this.$set(this.form, 'payCxMoney', this.maxPlanMoney)
          // } else {
          //   this.$set(this.form, 'payMoney', 0)
          //   this.$set(this.form, 'payCxMoney', 0)
          // }
          if (this.maxPlanMoney >= 0) {
            this.placeholder = '请输入付款金额' + `(金额范围 0 ~ ${this.maxPlanMoney})`
          } else {
            this.placeholder = '请输入付款金额' + `(金额范围 ${this.maxPlanMoney} ~ 0 )`
          }
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    getLocal () {
      let own = localStorage.getItem('USER')
      this.form.payOwner = JSON.parse(own).username
      return JSON.parse(own).username
    },
    onisChanges (e) {
      if (e.target.checked) {
        this.iscollection = true
        this.ischeckeds = true
        this.$set(this.form.invoiceBo, 'invoiceMoney', this.form.payMoney)
      } else {
        this.iscollection = false
        this.ischeckeds = false
        this.$set(this.form.invoiceBo, 'invoiceMoney', '')
      }
    },
    isInvoice (e) {
      if (e.target.value === 1) {
        this.isTicket = true
      } else {
        this.isTicket = false
        this.ischeckeds = false
        this.iscollection = false
      }
    },
    radioChange (e) {
      this.form.payStatus = e.target.value
      if (e.target.value === 1) {
        this.isRecords = true
        this.ischecked = true
        this.generated = true
      } else {
        this.isRecords = false
        this.generated = false
        this.ischecked = false
        // this.form.payMoneyActual = null
        // this.form.payDateActual = null
        this.$set(this.form, 'payDateActual', null)
        this.$set(this.form, 'payMoneyActual', null)
      }
    },
    onisChange (e) {
      if (e.target.checked) {
        this.ischecked = true
        this.generated = true
      } else {
        this.generated = false
        this.ischecked = false
        this.$set(this.form, 'payDateActual', '')
        this.$set(this.form, 'payMoneyActual', '')
      }
    },
    maskClick () {
      this.resetForm()
      this.$emit('close')
    },
    resetDialogData () {
      this.publicDia.visible = false
    },
    onChange (val, mode) {
      this.form.payDate = mode
    },
    onChangePractical (val, mode) {
      this.form.actualPayDate = mode
    },
    handleOk (val) {
      // if (this.form.payMoney > this.maxPlanMoney) {
      //   this.$message.warning(`金额不能大于采购单金额`)
      //   return
      // }
      // if (this.form.payMoneyActual > this.maxPlanMoney) {
      //   this.$message.warning(`金额不能大于采购单金额`)
      //   return
      // }
      // 动态范围判断（支持负数范围）
      if (this.maxPlanMoney >= 0) {
        if (this.form.payMoney < 0 || this.form.payMoney > this.maxPlanMoney) {
          this.$message.warning(`金额应在 0 ~ ${this.maxPlanMoney} 之间`)
          return
        }
      } else {
        if (this.form.payMoney < this.maxPlanMoney || this.form.payMoney > 0) {
          this.$message.warning(`金额应在 ${this.maxPlanMoney} ~ 0 之间`)
          return
        }
      }
      if (this.form.payInvoice === 1) {
        if (this.isincludingTax && (!this.form.invoiceBo.taxRate || this.form.invoiceBo.taxRate === '0')) {
          this.$message.warning('专用发票请填写税率')
          return
        }
      }
      this.$refs.formRef.validate((valid) => {
        if (this.$refs.uploadRef.setCount !== 0) {
          this.form.fileIds = this.uploadFileList
        }
        if (!this.ischecked) {
          delete this.form.payDateActual
        }
        if (val === 1) {
          this.form.checkFlag = val
          this.form.isBack = 1
        } else {
          this.form.checkFlag = null
          this.form.isBack = null
        }
        if (valid) {
          this.loading = true
          if (this.title === `[新建]-${this.$tree([], 'purchase/paymentSchedule/index')}`) {
            if (this.iscollection) {
              let invoiceBo = JSON.stringify(this.form.invoiceBo)
              this.form.invoiceBo = invoiceBo
            } else {
              delete this.form.invoiceBo
            }
            // this.form.creator = this.getLocal()
            if (this.form.checkStatus === 2) {
              this.form.checkFlag = 0
            }
            this.$post('/payPlan/add', this.form).then(res => {
              if (res.data.status === 1) {
                this.$message.success(res.data.message)
                this.$emit('success')
                this.resetForm()
              } else {
                this.$message.warning(res.data.message)
              }
            }).finally(r => {
              setTimeout(() => {
                this.loading = false
              }, 200)
            })
          } else {
            // this.form.updater = this.getLocal()
            delete this.form.createTime
            delete this.form.updateTime
            if (this.form.checkStatus === 2) {
              this.form.checkFlag = 0
            }
            this.$post('/payPlan/update', this.form).then(res => {
              if (res.data.status === 1) {
                this.$message.success(res.data.message)
                this.$emit('success')
                this.resetForm()
              } else {
                this.$message.warning(res.data.message)
              }
            }).finally(r => {
              setTimeout(() => {
                this.loading = false
              }, 200)
            })
          }
        }
      })
    },
    resetForm () {
      this.uploadFileList = []
      setTimeout(() => {
        // this.nameObj = {}
        this.purchaseDetails = ''
        this.dealBigMoneyss = ''
        this.maxPlanMoney = 0
        this.editMaxPlanMoney = 0
        this.editPlanMoneyId = null
        this.generated = false
        this.isTicket = false
        this.isRecords = false
        this.iscollection = false
        this.payments = false
        this.ischecked = false
        this.ischeckeds = false
        this.disabled = false
        this.isDisabled = false
        this.userDisabled = false
        this.maskDiv = false
        this.disselectSupplier = false
        this.form = {
          payDate: moment().format('YYYY-MM-DD'), // 款项日期
          payInvoice: 0, // 收到发票
          payStatus: 0,
          payType: 0,
          actualPayDate: null,
          invoiceBo: {
            includingTax: 1,
            taxRate: '',
            taxes: '',
            invoiceMoney: ''
          }
        }
      }, 500)
    },
    close () {
      this.resetForm()
      this.$emit('close')
    },
    addEdited () {
      this.maskDiv = false
    },
    initData (row) {
      this.$nextTick(() => {
        this.form = row
        // getProjectNameById(this.form.projectId).then(res => {
        //   this.$set(this.form, 'projectName', res)
        // })
        this.editMaxPlanMoney = this.form.payMoney // 设置金额
        this.disabled = true
        if (this.form.fileIds) {
          // string 转 数组  循环获取附件信息
          let fileList = this.form.fileIds.split(',')
          this.$nextTick(() => {
            this.$refs.uploadRef.getFile(fileList)
          })
        }
        if (this.form.purchaseId) {
          this.editPlanMoneyId = this.form.purchaseId
          this.checkAmountLimit(this.form.purchaseId, 0)
          // this.procurementSelect()
        }
        if (row.checkStatus !== '' && row.checkStatus !== null && row.checkStatus !== 2) {
          // this.userDisabled = true isDisabled
          this.maskDiv = true
          this.$message.warning('请先撤回后，再点击修改')
        } else if (row.checkStatus === 2) {
          this.maskDiv = false
          this.isDisabled = true
        } else {
          this.maskDiv = false
        }
        this.dealBigMoneyss = dealBigMoneys(this.form.payMoney)
      })
    },
    handleClose () {
      this.publicDia.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
.ant-calendar-picker {
  width: 80%;
}
.maskDiv {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.2);
}

.ant-form-item {
  display: flex;

  .ant-form-item-label {
    width: 110px;
  }

  .ant-form-item-control-wrapper {
    flex: 1;
  }
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.isDisabled {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/views/purchase/paymentSchedule/addEdit.vue